import { Component, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { MDBModalRef } from "ng-uikit-pro-standard";
import { clearCart } from "src/app/_actions/cart.actions";

@Component({
  selector: "app-product-home-modal",
  standalone: false,
  templateUrl: "./product-home-modal.component.html",
  styleUrls: ["./product-home-modal.component.scss"],
})
export class ProductHomeModalComponent implements OnInit {
  callbackFunction: () => void;
  cancelCallback: () => void;

  constructor(private store: Store<{}>, public modalRefCart: MDBModalRef) {}

  ngOnInit(): void {
    console.log("ModelRefCart: ", this.modalRefCart.content);
  }

  startOver() {
    if (this.callbackFunction) {
      this.callbackFunction();
    } else {
      this.store.dispatch(clearCart());
    }
    this.modalRefCart.hide();
  }

  cancel() {
    if (this.cancelCallback) {
      this.cancelCallback();
    }
    this.modalRefCart.hide();
  }
}
